import type {ProgramTemplateBlockTableRowField} from "services/api";

export const getHintContent = (field: ProgramTemplateBlockTableRowField) => {
  if (!field.targetValue) {
    return null;
  }

  if (!field.operator) {
    return `Рекомендовано ${field.targetValue}`;
  }

  if (field.operator === "required") {
    return `Значение должно быть равно ${field.targetValue}`;
  }

  if (field.operator === "min") {
    return `Значение должно быть не меньше ${field.targetValue}`;
  }

  if (field.operator === "max") {
    return `Значение должно быть не больше ${field.targetValue}`;
  }

  return null;
};